/**
 * Print Depot — scroll reveal
 *
 * Two kinds of target:
 *   [data-pd-reveal-group]  — a pd-* section whose .pd-reveal children are held
 *                             at the start of their animation until scrolled to.
 *   .shopify-section        — every other section on the page, revealed as a
 *                             whole so theme-owned sections still feel polished.
 *
 * pd-base.css pauses these only while <html data-pd-motion="on">, which an
 * inline head script sets before first paint. Setting window.__pdReveal tells
 * that script's failsafe this file loaded, so content is never left hidden.
 *
 * Horizon scrolls .page-wrapper rather than the document on desktop, so the
 * observer roots against that element when it exists.
 */
(() => {
  window.__pdReveal = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const SELECTOR = '[data-pd-reveal-group], .content-for-layout > .shopify-section';
  const observed = new WeakSet();

  const reveal = (el) => {
    el.setAttribute('data-pd-in-view', '');
    observer.unobserve(el);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) reveal(entry.target);
      }
    },
    {
      root: document.querySelector('.page-wrapper'),
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.05,
    }
  );

  const scan = () => {
    for (const el of document.querySelectorAll(SELECTOR)) {
      if (observed.has(el) || el.hasAttribute('data-pd-in-view')) continue;

      // Mirrors the two exclusions in pd-base.css: sticky children can't live
      // inside an animating transform, and sections that stagger their own
      // children must not also animate as a whole.
      if (
        el.classList.contains('shopify-section') &&
        el.querySelector('.sticky-content, [data-pd-reveal-group]')
      ) {
        continue;
      }

      observed.add(el);
      observer.observe(el);
    }
  };

  scan();

  // Re-arm after theme editor edits and Horizon's client-side navigation.
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) event.target.removeAttribute('data-pd-in-view');
    scan();
  });
  document.addEventListener('DOMContentLoaded', scan);
})();
